import { MARK_ICON, MARK_LABEL } from "@/shared/lib/labels";
import type { MarkStatus } from "@/shared/api/book";
import { cn } from "@/shared/lib/utils";

const OPTIONS = Object.keys(MARK_LABEL) as MarkStatus[];

/** „Hol tartok vele?" — a gyakorlat állapotának megjelölése.
 *
 *  Nem szegmentált vezérlő: a három felirat hosszú, ott elcsúszna. Helyette teljes
 *  feliratú, ikonos gombok, amik keskeny kijelzőn tördelnek. A kiválasztott arany
 *  kerettel és `gold-soft` háttérrel emelkedik ki; újra rákoppintva visszavonható.
 */
export function MarkPicker({
  value,
  onChange,
  disabled,
}: {
  value: MarkStatus | null;
  onChange: (next: MarkStatus | null) => void;
  disabled?: boolean;
}) {
  return (
    <div role="group" aria-label="Hol tartok vele?" className="flex flex-wrap gap-2">
      {OPTIONS.map((status) => {
        const Icon = MARK_ICON[status];
        const active = value === status;
        return (
          <button
            key={status}
            type="button"
            aria-pressed={active}
            disabled={disabled}
            onClick={() => onChange(active ? null : status)}
            className={cn(
              "flex min-h-11 items-center gap-2 rounded-md border px-3.5 text-[14px] transition-colors disabled:opacity-50",
              active
                ? "border-gold bg-gold-soft font-semibold text-ink"
                : "border-line font-medium text-ink-soft hover:bg-paper",
            )}
          >
            <Icon size={16} className={cn("shrink-0", active ? "text-gold-text" : "text-muted")} />
            {MARK_LABEL[status]}
          </button>
        );
      })}
    </div>
  );
}
